// firebase/messaging.js
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

// Honor global disable flag.
// Default behavior when no env var is set: DISABLED (push is opt-in).
// Set VITE_FIREBASE_ENABLED=true (or REACT_APP_FIREBASE_ENABLED=true) to enable.
const viteEnv = typeof import.meta !== 'undefined' ? (import.meta.env || {}) : {};

const FIREBASE_ENABLED_RAW =
    (viteEnv && viteEnv.VITE_FIREBASE_ENABLED) ??
    process.env.REACT_APP_FIREBASE_ENABLED ??
    '';
const FIREBASE_ENABLED = String(FIREBASE_ENABLED_RAW).toLowerCase() === 'true';

const firebaseConfig = {
  apiKey: 'AIzaSyDwbfIHdNLxpTG14lcjjXJ8AkNIAbVDGnM',
  authDomain: 'barenaerp.firebaseapp.com',
  projectId: 'barenaerp',
  storageBucket: 'barenaerp.firebasestorage.app',
  messagingSenderId: '94834123859',
  appId: '1:94834123859:web:ceb8ab2de1c35444e092a6',
};

// Detect placeholder config so we can skip initialization when none has been set.
// (Set apiKey/projectId to '' or 'YOUR_*' to disable without env vars.)
const PLACEHOLDER_API_KEY = !firebaseConfig.apiKey || firebaseConfig.apiKey.startsWith('YOUR_');
const PLACEHOLDER_PROJECT = !firebaseConfig.projectId || firebaseConfig.projectId.startsWith('YOUR_');

// Use a named app to avoid reusing an incomplete default app
const APP_NAME = 'messaging-app';
let app = null;

if (FIREBASE_ENABLED && !PLACEHOLDER_API_KEY && !PLACEHOLDER_PROJECT) {
    try {
        app = getApps().find(a => a.name === APP_NAME);
        if (!app) app = initializeApp(firebaseConfig, APP_NAME);
    } catch (e) {
        console.warn('[Firebase] Client initialization failed - push notifications disabled:', e?.message || e);
        app = null;
    }
} else {
    if (typeof console !== 'undefined') {
        //iph todo: 47
        //console.log('[Firebase] Disabled via config - push notifications skipped');
    }
}

export const fetchFCMToken = async () => {
    if (!FIREBASE_ENABLED || !app) return null;
    try {
        const supported = await isSupported();
        if (!supported) return null;
        // Ensure we have permission and SW registered before getToken
        if (typeof Notification !== 'undefined' && Notification.permission !== 'granted') {
            const perm = await Notification.requestPermission();
            if (perm !== 'granted') return null;
        }

        // Register service worker (required for reliable token in many browsers)
        if ('serviceWorker' in navigator) {
            try {
                // Keep the registration reference so getToken uses the same SW scope
                var swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            } catch (e) {
                // continue even if SW register fails
            }
        }

        const messaging = getMessaging(app);
        const vapidKey = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_FIREBASE_VAPID_KEY)
            || process.env.REACT_APP_FIREBASE_VAPID_KEY;
        // If a VAPID key is provided (recommended), include SW registration to ensure proper scope
        const token = await getToken(messaging, {
            vapidKey: vapidKey || undefined,
            serviceWorkerRegistration: typeof swReg !== 'undefined' ? swReg : undefined,
        });
        return token || null;
    } catch (err) {
        console.warn('FCM token fetch failed:', err?.message || err);
        return null;
    }
};

export const subscribeToForegroundMessages = async (handler) => {
    if (!FIREBASE_ENABLED || !app) return () => {};
    try {
        //iph todo: 47
        //console.log('Checking FCM support...');
        const supported = await isSupported();
        if (!supported) {
            //iph todo: 47
            //console.log('FCM not supported in this browser');
            return () => {};
        }
        //iph todo: 47
        //console.log('FCM supported, getting messaging instance...');
        const messaging = getMessaging(app);
        //iph todo: 47
        //console.log('Setting up onMessage listener...');
        const unsubscribe = onMessage(messaging, (payload) => {
            //iph todo: 47
            //console.log('FCM onMessage triggered:', payload);
            try {
                handler && handler(payload);
            } catch (e) {
                console.error('Error in FCM handler:', e);
            }
        });
        //iph todo: 47
        //console.log('FCM listener registered successfully');
        return unsubscribe;
    } catch (e) {
        console.error('Error setting up FCM listener:', e);
        return () => {};
    }
};
